var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9838 2.25016H10C9.58579 2.25016 9.25 2.58595 9.25 3.00016C9.25 3.41437 9.58579 3.75016 10 3.75016H13.065L9.39837 20.2502H6C5.58579 20.2502 5.25 20.5859 5.25 21.0002C5.25 21.4144 5.58579 21.7502 6 21.7502H9.98524C9.99558 21.7504 10.0059 21.7504 10.0162 21.7502H14C14.4142 21.7502 14.75 21.4144 14.75 21.0002C14.75 20.5859 14.4142 20.2502 14 20.2502H10.935L14.6016 3.75016H18C18.4142 3.75016 18.75 3.41437 18.75 3.00016C18.75 2.58595 18.4142 2.25016 18 2.25016H14.0148C14.0044 2.24995 13.9941 2.24995 13.9838 2.25016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/Italic.f028e7bf2ee863df6e382c0e14b873c4.svg";
export { ForwardRef as ReactComponent };